import { Fragment } from 'react';
import Citizenship from '../shared/citizenship';
import EditData from '../shared/edit-data';
import FamilyCoexistence from '../shared/family-coexistence';
import Fatherhood from '../shared/fatherhood';
import AccordionGenerality from '../shared/generality';
import Motherhood from '../shared/motherhood';
import Document from '../shared/document';
import AddressForeign from '../shared/address-foreign';
import CivilStatus from '../shared/civil-status';
import AccordionGeneralityResearch from '../shared/generality-research';
import AccordionGeneralityResearchSipo from '../shared/generality-research-sipo';
import BirthdayDocument from '../shared/birthday-document';
import { __PERSON_API_URL__ } from 'shell/constants/environment';

interface SubscriptionTransferOtherMunicipalityProps {
  isCohabitation?: boolean;
  isAire?: boolean;
  withoutFamily?: boolean;
  isCitizenship?: boolean;
  generalityWithResearch?: boolean;
  isTransferNew?: boolean;
  isTransferAggregation?: boolean;
  isBornSolo?: boolean;
  validityEqualBirthday?: boolean;
  hasResearchSipo?: boolean;
  urlEditSipo?: string;
  urlBackendSipo?: string;
}

const SubscriptionTransferOtherMunicipalityAct = ({
  isCohabitation = false,
  isAire = false,
  withoutFamily = false,
  isCitizenship = false,
  generalityWithResearch = false,
  isTransferNew = false,
  isTransferAggregation,
  isBornSolo,
  validityEqualBirthday = true,
  hasResearchSipo,
  urlEditSipo,
  urlBackendSipo,
}: SubscriptionTransferOtherMunicipalityProps): React.ReactElement => {
  return (
    <Fragment>
      <FamilyCoexistence isCohabitation={isCohabitation} withoutFamily={withoutFamily} />
      <AddressForeign isAire={isAire} />
      <EditData isCohabitation={isCohabitation} isAire={isAire} />
      {hasResearchSipo ? (
        <AccordionGeneralityResearchSipo
          isCohabitation={isCohabitation}
          isAire={isAire}
          redirectPath={urlEditSipo}
          url={urlBackendSipo ? `${__PERSON_API_URL__}${urlBackendSipo}` : undefined}
        />
      ) : generalityWithResearch ? (
        <AccordionGeneralityResearch isCohabitation={isCohabitation} isAire={isAire} />
      ) : (
        <AccordionGenerality isCohabitation={isCohabitation} isAire={isAire} />
      )}
      <BirthdayDocument
        isAire={isAire}
        isTransferNew={isTransferNew}
        isTransferAggregation={isTransferAggregation}
        isBornSolo={isBornSolo}
      />
      <Fatherhood isCohabitation={isCohabitation} isAire={isAire} isTransferNew={isTransferNew} />
      <Motherhood isCohabitation={isCohabitation} isAire={isAire} isTransferNew={isTransferNew} />
      <Citizenship
        isTransferNew={isTransferNew}
        isTransferAggregation={isTransferAggregation}
        validityEqualBirthday={validityEqualBirthday}
      />
      <CivilStatus isCitizenship={isCitizenship} />
      <Document isAire={isAire} />
    </Fragment>
  );
};

SubscriptionTransferOtherMunicipalityAct.displayName =
  'SubscriptionTransferOtherMunicipalityAct component';

export default SubscriptionTransferOtherMunicipalityAct;
